import AgentProfile from './AgentProfile.jsx'

export default AgentProfile
